const {LOCALES} = window.SITE_DATA;

export {LOCALES};
